<template>
  <div class="container-fluid mt-4 px-1">
    <div class="row gx-3"> 
      <div class="col-md-4">
        <ranking-list-card
          :horizontal-break="false"
          :card="{
            title: '이벤트 데이터',
          }"
          :item="dataList"
        >
        </ranking-list-card>
      </div>

      <div class="col-md-4">
        <div class="card shadow-sm p-4 h-100">
              <div class="col-md-6">
                <h6 class="pb-4 mb-0">입력 데이터</h6>
              </div>
          <form @submit.prevent="submitEvent">
            <!-- 원재료 선택 -->
            <div class="mb-3">
              <label for="epc" class="form-label">재료명</label>
              <select v-model="epc" class="form-select" id="epc" >
                <option value="">선택</option>
                <option v-for="item in rawMaterialList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 스캔장소 (readPoint) -->
            <div class="mb-3">
              <label for="readPoint" class="form-label">스캔장소 (readPoint)</label>
              <select v-model="form.readPoint.manualURI" class="form-select" id="readPoint">
                <option value="">선택</option>
                <option v-for="item in readPointList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 입고장소 (bizLocation) -->
            <div class="mb-3">
              <label for="bizLocation" class="form-label">입고장소 (bizLocation)</label>
              <select v-model="form.bizLocation.manualURI" class="form-select" id="bizLocation">
                <option value="">선택</option>
                <option v-for="item in bizLocationList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 수량 -->
            <div class="mb-3">
              <label for="eventTime" class="form-label">이벤트 발생 시간</label>
              <input type="datetime-local" v-model="eventTimeTemp" class="form-control" id="eventTime" />
            </div>

            <!-- 등록 버튼 -->
            <div class="text-end">
              <button type="submit" class="btn btn-success">이벤트 등록</button>
            </div>
          </form>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="card shadow-sm p-4 h-100">
          <div class="col-md-6">
            <h6 class="pb-4 mb-0">위치정보</h6>
          </div>
          <div class="p-1">
            <map-picker
              :key="mapKey"
              v-model="mapLocation"
              :center="mapCenter"
              :height="'400px'"
              :zoom="13"
              :clickable="false"
              :imageUrl="rpImageUrl"
            />
          </div>
        </div>
      </div>
    </div>

    <EventListTable
      :eventList="recentEventList"
      :loading="loadingEvents"
      :minBodyHeight="300"
      emptyMessage="최근 이벤트가 없습니다."
    />
  </div>
</template>
<script>
import { fetchRawMaterialData, fetchBizLocationData, fetchReadPointData } from "../../api/common/initDataAPI";
import { pollEpcisEvent, saveBlockChain } from "@/api/common/blockchain.js";
import RankingListCard from "@/examples/Cards/RankingListCard.vue";
import EventListTable from "@/views/components/EventListTable.vue";
import MapPicker from "@/components/map/mapPicker.vue";
import api from '@/api/api';

export default {
  name: "EventPrc1",
  components: {
    RankingListCard,
    EventListTable,
    MapPicker,
  },
  inject: ['showLoading', 'hideLoading'],
  computed: {
    mfId() {
      return this.$store.getters['UserStore/getMfId'];
    },
    dataList() {
      return [{
        title: '이벤트타입',
        date: 'EventType',
        amount: 'ObjectEvent',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '액션',
        date: 'Action',
        amount: 'ADD',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '업무단계',
        date: 'bizStep',
        amount: 'RECEIVING',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '처리상태',
        date: 'Disposition',
        amount: 'IN_PROGRESS',
        icon: 'fa-info',
        color: 'dark',
      }
      ]
    },
    mapCenter() {
      if (this.mapLocation) {
        return this.mapLocation;
      }
      const mfInfo = this.$store.getters["UserStore/getMfInfo"];
      if (mfInfo?.lat && mfInfo?.lng) {
        return [mfInfo.lat, mfInfo.lng];
      }
      return [35.8714354, 128.601445]; // 기본 좌표
    },
  },
  watch: {
    'form.readPoint.manualURI'(urn) {
      const sel = this.readPointList.find(r => r.urn === urn);
      if (sel && sel.blId != null) {
        const blId = sel.blId;
        if(blId){
          const selBlId = this.bizLocationList.find(b => b.id === blId);
          if(selBlId) this.form.bizLocation.manualURI = selBlId.urn;
        }
        if(sel.imageUrl) this.rpImageUrl = sel.imageUrl;
        else this.rpImageUrl = null;
      }
      if (sel && sel.lat != null && sel.lng != null) {
        const lat = Number(sel.lat);
        const lng = Number(sel.lng);
        this.mapLocation = [lat, lng];
        this.mapKey++;
      } else {
        this.mapLocation = null;
        this.mapKey++; // 필요시
      }
    },
  },
  data() {
    return {
      loadingEvents: true,
      epc: '',
      crtEventID: '',
      eventTimeTemp: '',
      form: {
        parentID: '',
        childEPCs: [],
        eventType: "ObjectEvent",
        action: 'ADD',
        businessStep: 'RECEIVING',
        disposition: 'IN_PROGRESS',
        eventTimeSelector: '',
        eventTime: {},
        quantity: '1',
        epcList: [],
        readpointselector: 'manually',
        readPoint: {
          gcpLength: null,
          manualURI: "",
        },
        businesslocationselector: "manually",
        bizLocation: {
          gcpLength: null,
          manualURI: "",
        },
        vocabularySyntax: 'URN',
        ordinaryEvent: true,
        RecordTimeOption: 'no',
        recordTimeType: 'SAME_AS_EVENT_TIME',
        PersistentDispositionType: null,
        PersistentDisposition: null,
        persistentDispositionCount: 0,
        persistentDispositionList: [],
        businessTransactionCount: 0,
        businessTransactionList: [],
        errorCorrectiveCount: 0,
        errorCorrectiveIdsList: [],
        eventID: false,
        eventIdType: 'UUID',
        hashAlgorithm: 'sha-256',
      },
      rawMaterialList: [],
      bizLocationList: [],
      readPointList: [],

      mapLocation: null,
      mapKey: 0,

      recentEventList: [],

      rpImageUrl: null,
    }
  },
  async mounted() {
    this.eventTimeTemp = this.setDefaultTime();

    let now = new Date()
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
    now.setSeconds(now.getSeconds(), 0)
    now = now.toISOString().slice(0, -1)

    this.form.eventTime = {
      specificTime: now,
      fromTime: now,
      toTime: now,
      timeZoneOffset: '+09:00'
    }

    this.$store.state.DesignTestDataStore.eventType = "ObjectEvent";
    const [rawList, bizList, readList] = await Promise.all([
      fetchRawMaterialData(this.mfId),
      fetchBizLocationData(this.mfId),
      fetchReadPointData(this.mfId, 'Y'),
    ]);
    this.rawMaterialList = rawList;
    this.bizLocationList = bizList;
    this.readPointList   = readList;
    this.fetchEventListData();

  },
  methods: {
    async submitEvent(){
      this.form.eventTime = this.syncEventTimeFromTemp(this.eventTimeTemp);
      this.showLoading?.('이벤트를 EPCIS에 저장중...');
      try {
        const response = await api.post("/rawMaterial/maxSerial", {urn: this.epc});
        const result = response.data.result;
        const paddedSerial = String(result.maxSerial).padStart(4, '0');
        this.form.epcList = [this.epc  + '.' + paddedSerial];

        this.$store.dispatch('TestDataJsonPreparator/jsonPreparation', {
          formData: this.form
        })
      
        this.$store.commit(
          'TestDataGeneratorStore/populateTestDataInput',
          JSON.stringify(
            this.$store.state.TestDataJsonPreparator.testDataInputTemplate
          )
        )

        await this.$store.dispatch('TestDataGeneratorStore/testdataGenerator');
        let dataResult = JSON.stringify(this.$store.state.TestDataGeneratorStore.testDataOutput, null, 2);

        const captureRes = await this.captureApi(dataResult);
        if (captureRes.success) {
          this.showLoading?.('이벤트를 블록체인에 저장중...');

          // ✅ 공통 유틸 사용 (EPCIS → 블록체인)
          const committedEvent = await pollEpcisEvent(this.crtEventID, {
            timeout: 60000, startInterval: 800, maxInterval: 4000
          });
          await saveBlockChain(this.crtEventID, committedEvent, 60000);
          
          this.toastSuccess("저장 되었습니다.");
          setTimeout(() => this.fetchEventListData(), 2000);
        }
      } catch (error) {
        console.error("정보 불러오기 실패:", error);
      } finally {
        this.hideLoading?.();
      }
    },
    async captureApi(dataResult){
      try {
        this.crtEventID = '';
        const jsonData = JSON.parse(dataResult);

        const event = jsonData.epcisBody.eventList[0];
        if (this.mfId) {
          event["cbv:extension"] = {
            companyPrefix: this.mfId
          };
        }

        event.epcList = this.form.epcList;

        if (!event.eventID) {
          const id = (crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2));
          this.crtEventID = `urn:uuid:${id}`;
          event.eventID = this.crtEventID;
        }

        delete event.parentID;
        delete event.childEPCs;

        const response = await fetch(`/api/epcisAPI/capture`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(jsonData),
        });

        if (!response.ok) {
          throw new Error("응답 오류: " + response.status);
        }

        const text = await response.text();
        const result = text ? JSON.parse(text) : {};
        return { success: true, data: result };

      } catch (e) {
        this.toastError("전송 중 오류가 발생했습니다.");
        console.error('전송 실패:', e);
        return { success: false, error: e.message || e };
      }
    },
    async fetchEventListData() {
      this.loadingEvents = true;
      try {
        const [res] = await Promise.all([
          api.get(`/event/list`, {
            params: { 
              mfId: this.mfId,
              eventType: this.form.eventType,
              bizStep: this.form.businessStep.toLowerCase(),
              disposition: this.form.disposition.toLowerCase()
            }
          }),
          new Promise(r => setTimeout(r, 600))
        ]);

        const result = res.data.result;
        this.recentEventList = result.recentEventList || [];
      } catch (error) {
        console.error("정보 불러오기 실패:", error);
      } finally {
        this.loadingEvents = false;
      }
    }
  },
};
</script>